import IMApp from "./IMApp";
import IMStorage from "./IMStorage";
import StringUtils from "./IMStringUtils";
import IMUsers from "./IMUsers";



export default class IMGroups {

    static groups = [];
    static curgroup = [];

    static save() {
        IMStorage.set('', 'GroupInfo' + IMApp.user.uid, IMGroups.groups);
    }

    static getGroup(groupkey) {
        for (let i = 0; i < IMGroups.groups.length; i++) {
            if (IMGroups.groups[i].groupkey === groupkey) {
                return IMGroups.groups[i];
            }
        }
        return null;
    }

    static getGroupHeadUrls(groupkey) {
        let headurls = [];
        let group = IMGroups.getGroup(groupkey);
        if (group && group.users) {
            for (let i = 0; i < group.users.length; i++) {
                headurls.push(group.users[i].headurl);
            }
        }
        return headurls;
    }

    static addGroup(groupinfo) {
        IMGroups.groups.push(groupinfo);
    }

    static isAdmin(group, uid = IMApp.user.uid) {
        if (group == null) {
            return false;
        }
        for (let i = 0; i < group.groupadmins.length; i++) {
            if (group.groupadmins[i] === uid) {
                return true;
            }
        }
        return false;
    }

    static isHost(group, uid = IMApp.user.uid) {
        if (group == null) {
            return false;
        }
        return group.grouphost === uid;
    }

    static refreshGroup(groupkey, data) {
        for (let i = 0; i < IMGroups.groups.length; i++) {
            let group = IMGroups.groups[i];
            if (group.groupkey === groupkey) {
                for (var key in data) {
                    group[key] = data[key];
                }
                break;
            }
        }
    }

    static getGroups() {
        let groups = [];
        for (let i = 0; i < IMGroups.groups.length; i++) {
            let group = IMGroups.groups[i];
            if (group.isExit) {
                continue;
            }

            let g = {};
            let uids = [];
            for (let j = 0; j < group.users.length; j++) {
                uids.push(group.users[j].uid);
            }
            g.groupkey = group.groupkey;
            g.titleName = StringUtils.isNotEmpty(group.groupname) ? group.groupname : IMUsers.getNames(uids).join(',');
            g.headurls = IMUsers.getHeadurl(uids);
            groups.push(g);
        }
        return groups;
    }
}